export default __webpack_public_path__ + "static/media/phishgnn_figure.c0457c7b.png";